const prefix = 'PROJECTS_SETTINGS';

export const GET_INVOICE_TEMPLATES = `${prefix}/GET_INVOICE_TEMPLATES`;
export const ADD_INVOICE_TEMPLATES = `${prefix}/ADD_INVOICE_TEMPLATES`;

